module.exports = __webpack_public_path__ + "media/images/lig/lig-texture-f35aa4cfc0ec4e810955d20d693c222d.svg";